import uuid from "uuid";

const replayKey = "replay";

class ReplayStorage {
  saveMessage(message: any) {
    const messages = JSON.parse(localStorage.getItem(replayKey) || "[]");

    const id = uuid.v4();

    messages.push({ id, message });
    localStorage.setItem(replayKey, JSON.stringify(messages));
    return id;
  }

  getMessage(id: string) {
    const storage = localStorage.getItem(replayKey);

    if (storage) {
      const messages = JSON.parse(storage);
      return messages.find((message: any) => message.id === id)?.message;
    }
    return null;
  }

  clear() {
    localStorage.removeItem(replayKey);
  }
}

export const replayStorage = new ReplayStorage();
